import { DEAL_TYPE, FEE_TYPE, FEE_TYPE_META } from 'constants/dealConstants';
import { generateSelectOptions } from 'helpers/inputHelper';
import { useMemo } from 'react';

export function useFeeTypeOptions({ dealType }) {
  const feeTypeOptions = useMemo(() => {
    let _options = generateSelectOptions({ metaObj: FEE_TYPE_META });

    // Fixed deals only support Fixed fee type. Until a deal type is chosen, show all
    // options so the select is usable while filling the form top-down.
    if (dealType === DEAL_TYPE.FIXED) {
      _options = _options.filter((option) => option.value === FEE_TYPE.FIXED);
    }

    return _options;
  }, [dealType]);

  return { feeTypeOptions };
}
